module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"Email","existingConnectionWithEmail":"You already have a connexion with this email","name":"Name","noConnection":"You don\u0027t have any connection, start by adding one!"},"fr":{"existingConnectionWithEmail":"You already have a connexion with this email","email":"Email","name":"Name","noConnection":"You don\u0027t have any connection, start by adding one!"}}')
  delete Component.options._Ctor
}
